"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class FormDatosPropietario extends _react.Component {
  constructor(props) {
    super(props);
    this.onBlurInput = this.onBlurInput.bind(this);
  }

  onBlurInput(event) {
    this.props.onChange(event.target.name, event.target.value);
  }

  render() {
    const {
      nombre,
      apellido,
      dni
    } = this.props;
    return (0, _react2.jsx)("div", {
      css: _style.default.root
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "subtitle1",
      css: _style.default.title
    }, "Datos del Propietario"), (0, _react2.jsx)(_material.Typography, {
      variant: "body2",
      css: _style.default.description
    }, "Son los datos del due\xF1o de la propiedad, los mismos no son visibles para el usuario."), (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Nombre",
      name: "nombre",
      fullWidth: true,
      css: _style.default.inputGrid,
      defaultValue: nombre,
      onBlur: this.onBlurInput
    }), (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Apellido",
      name: "apellido",
      fullWidth: true,
      css: _style.default.inputGrid,
      defaultValue: apellido,
      onBlur: this.onBlurInput
    }), (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "DNI",
      name: "dni",
      fullWidth: true,
      css: _style.default.inputGrid,
      defaultValue: dni,
      onBlur: this.onBlurInput
    }));
  }

}

var _default = FormDatosPropietario;
exports.default = _default;